import type { FC, MutableRefObject } from 'react';

import { Button } from '../../Button/Button';

import * as styles from './ActionButton.module.scss';

interface ActionButtonProps {
  onClick?: () => void;
  buttonRef?: MutableRefObject<HTMLButtonElement>;
}

export const ActionButton: FC<ActionButtonProps> = ({
  onClick,
  buttonRef,
  children,
}) => {
  return (
    <Button
      size="medium"
      variant="contained"
      ref={buttonRef}
      rounded
      active
      className={styles.button}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
